import type { StepKey } from '@/features/firstMile/slices/activeAccordionSlice';

/**
 *  These are constants used in the First Mile Features , Do not modify them unless you know what you are doing.
 */

/**
 * SHIPEMENT QUOTATION STEPS
 */
export const QUOTATION_STEPS = {
    QUOTE: 'quote',
    SUMMARY: 'summary',
    CREATE: 'create',
    REVIEW: 'review',
    SHIPMENT_CREATED: 'shipmentCreated',
} as const;

export type QuotationStep = (typeof QUOTATION_STEPS)[keyof typeof QUOTATION_STEPS];

/**
 * Package type constants
 */
export const CUSTOM_DIMENSION_CODE = 'OWNBOX';

/**
 * Default unit of measures
 */
export const DEFAULT_DIMENSION_UNIT = 'cm';
export const DEFAULT_WEIGHT_UNIT = 'kg';

export const QUOTATION_CACHE_KEYS = {
    CREATE_QUOTATION: 'quotation-shipping/create-quotation',
} as const;

export const PRICE_CONFIG = {
    TAX_CODE: 'STTXA',
    BILLING_CURRENCY: 'BILLC',
    BILLING_CURRENCY_CACHE_KEY: 'qtn.selected.currltycd',
    BASE_PRICE_CODE: 'SPRQT',
    BASE_PRICE_WITHOUT_TAX_CODE: 'SPRQN',
    TOTAL_PRICE_CODE: 'STOTA',
    INCLUDED_SERVICE_HIDDEN: 'Y',
    INDICATOR_YES: 'Y',
    XCH: 'XCH',
    SCH: 'SCH',
} as const;

export const SHIPMENT_INSURANCE_TYPE = 'II';

//export const SHIPMENT_TYPE_CODE = 'D';
export const SHIPMENT_TYPE_CODE = {
    DOCUMENT: 'D',
    PACKAGE: 'P',
};

export const CONSENT_FLOW_STATUS = {
    DONE: 'DONE',
    NO_NEED: 'NO_NEED',
    FAIL: 'FAIL',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
} as const;

export const TAG_PRIORITY = ['bestDeal', 'fastest'] as const;

export const MOBILE_SORT_DEFAULT = 'DESC';

export const DOCUMENT_DESCRIPTION_OTHER = 'Other';

export const ACCOUNT_TYPE_INDICATOR = {
    ACCOUNT: 'AC',
    NON_ACCOUNT: 'NAC',
};

export enum SHIPPER_BUSINESS_PARTY_TYPE {
    SHIPPER = 'SP',
    RECEIVER = 'RV',
}

export const QUOTATION_ACTIONS = {
    VIEW: 'view',
    SHARE: 'share',
    EDIT: 'edit',
    PRINT: 'print',
    DUPLICATE: 'duplicate',
};

export const QUOTATION_PAGE_ID = 'FM_QTN';

export const NADB_CONFIRMATION_STAGE = {
    STEP_1: '1',
    STEP_2: '2',
};

export const SHIPMENT_ACCORDION_STEPS = {
    SHIPMENT: 'SHIPMENT',
    SHIPPER: 'SHIPPER',
    RECEIVER: 'RECEIVER',
    SERVICE: 'SERVICE',
} satisfies Record<StepKey, StepKey>;

export const ROLE_TYPE_INDICATOR = {
    BUSINESS: 'BU',
    PRIVATE: 'PR',
    GOVERNMENT: 'GV',
};

export const PAYMENT_METHOD_CODE = {
    BILL_TO_ACCOUNT: 'BA',
    CASH: 'CS',
    CREDIT_CARD: 'CC',
    DEBIT_CARD: 'DC',
    DIGITAL_WALLET: 'DW',
} as const;

// Credit / Debit Card last-4 validation constants
export const CARD_LAST4_MAX_LENGTH = 4;
export const CARD_LAST4_PATTERN = /^\d{4}$/;

export const PAYMENT_VOID = 'VOID' as const;

export const DOCUMENT_PRINT_TYPES = {
    all: 'ALL',
    required: 'RQR',
    other: 'OTH',
} as const;

// Account type "Import"

export const IMP_ACCOUNT_TYPE = 'IMP';

export const FRONTENT_CACHE_KEYS = {
    AMOUNT_IN_DECIMAL_PLACE: 'amount.decimal.place',
    DISPLAY_INSURANCE_SERVICE_CODE: 'display.insurance.service.code',
    POUND_TO_KG_CONVERSION: 'weight_conversion_rate',
    CM_TO_INCH_CONVERSION: 'dimensions_conversion_rate',
} as const;

export const UOM_CONVERSION_DEFAULTS = {
    POUND_TO_KG_CONVERSION_MULPLIPLIER: 2.205,
    CM_TO_INCH_CONVERSION_MULPLIPLIER: 2.54,
} as const;

export const UNITS = {
    inches: 'in',
    pounds: 'lb',
} as const;
